import React, { useEffect, useState } from "react";
import DimondIcon from "../assets/image/diamond 2.png";
import WinImage from "../assets/image/Win.png";
import LoseImage from "../assets/image/Lose.png";
import WinBoxImage from "../assets/image/Win Box.png";

export default function WinnerDialog(props) {
  const { open, setOpen, winnerShow, userData, currentGame } = props;
  const [getUserData, setGetUserData] = useState();
  const [lossBet, setLossBet] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (open && !event.target.closest(".new-winner-dialog-overlay")) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener("click", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [open, setOpen]);

  useEffect(() => {
    const findWinnerUser = winnerShow?.winnerUserArray?.find(
      (user) => user?._id === userData?._id
    );
    setGetUserData(findWinnerUser);
  }, [userData, winnerShow]);

  useEffect(() => {
    const filterData = currentGame?.some(
      (item) => item?.userId === userData?._id
    );
    setLossBet(filterData);
  }, [userData, currentGame, winnerShow]);

  if (!open) return null;

  const isWin = getUserData && Object?.values(getUserData)?.length > 0;
  const isLoss = !isWin && lossBet;

  if (!isWin && !isLoss) return null;

  return (
    <div className="new-winner-dialog-overlay">
      {isWin ? (
        <div className="win-state-container">
          <img src={WinImage} className="win-lose-img win-anim" alt="Win" />
          <div className="win-amount-box">
            <p className="win-title">You Win</p>
            <div className="win-pill-container">
              <img src={WinBoxImage} className="win-box-bg" alt="win box" />
              <div className="win-pill-content">
                <img src={DimondIcon} alt="diamond" />
                <span>{getUserData?.userWinCoin ? getUserData?.userWinCoin : 0}</span>
              </div>
            </div>
          </div>
        </div>
      ) : isLoss ? (
        <div className="lose-state-container">
          <img src={LoseImage} className="win-lose-img lose-anim" alt="Lose" />
        </div>
      ) : null}
    </div>
  );
}
